import { splunk_message } from "../splunk_constant";

/**
 * Helper function to build a URL with query parameters based on an input object.
 * @param baseUrl - The base URL of the product.
 * @param queryParams - An object containing query parameters.
 * @returns A URL string with the appended query parameters.
 */
export function buildUrlWithParams(
    baseUrl: string,
    queryParams: Record<string, string | number | undefined> = {},
    splunkLogger?: any
): string {
    // Ensure mandatory parameters are present
    const { id, variantId, ...optionalParams } = queryParams;
    if (!id || !variantId) {
        throw new Error('Both "id" and "variantId" are required query parameters.');
    }

    const urlObj = new URL(baseUrl, window.location.origin);
    try {
        // Add mandatory query parameters
        urlObj.searchParams.append('id', String(id));
        urlObj.searchParams.append('variantId', String(variantId));

        // Add optional query parameters
        for (const [key, value] of Object.entries(optionalParams)) {
            if (value != null) { // Handles both `undefined` and `null`
            urlObj.searchParams.append(key, String(value).toLowerCase());
            }
        }
        splunkLogger({
            logType: 'info',
            data: splunk_message.SUCCESS.BUILD_URL_WITH_PARAMS_SUCCESS
          })
    } catch (error) {
        splunkLogger({
            logType: 'error',
            data: { ...splunk_message.ERROR.BUILD_URL_WITH_PARAMS_ERROR, error}
          })
        console.error('Error building URL with parameters:', error);
        // Return the base URL if any issues occur
        return baseUrl;
    }

    // Return the pathname and search string
    return `${urlObj.pathname}${urlObj.search}`;
}
